// ===============================================================
// 🧩 recaptcha.js — إنشاء reCAPTCHA مرة واحدة فقط
// ===============================================================

import { RecaptchaVerifier } from "firebase/auth";
import { auth } from "../firebase";

const RECAPTCHA_CONTAINER_ID = "recaptcha-container";

export function resetRecaptcha() {
  try {
    if (window.recaptchaVerifier?.clear) {
      window.recaptchaVerifier.clear();
    }
  } catch (e) {
    console.warn("⚠️ خطأ أثناء clear:", e);
  }
  delete window.recaptchaVerifier;
}

export const getOrCreateRecaptcha = async () => {
  if (typeof window === "undefined") {
    throw new Error("recaptcha: window is not available");
  }

  const container = document.getElementById(RECAPTCHA_CONTAINER_ID);
  if (!container) {
    throw new Error(
      `recaptcha: #${RECAPTCHA_CONTAINER_ID} element not found in DOM`
    );
  }

  if (window.recaptchaVerifier) {
    return window.recaptchaVerifier;
  }

  window.recaptchaVerifier = new RecaptchaVerifier(
    auth,
    RECAPTCHA_CONTAINER_ID,
    {
      size: "invisible",
      callback: () => {
        console.log("✅ تم التحقق من reCAPTCHA");
      },
      "expired-callback": () => {
        console.warn("⚠️ انتهت صلاحية reCAPTCHA");
        resetRecaptcha();
      },
    }
  );

  await window.recaptchaVerifier.render();
  return window.recaptchaVerifier;
};
